import React, { Component } from 'react';
import CreatorDashboardProfileCoverPhoto from './CreatorDashboardProfileCoverPhoto';
import CreatorDashboardProfileProfilePicture from './CreatorDashboardProfileProfilePicture';
import CreatorDashboardProfileUsername from './CreatorDashboardProfileUsername';
import CreatorDashboardProfileSocials from './CreatorDashboardProfileSocials';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";

class CreatorDashboardProfile extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="absolute z-20 top-16 left-24 sm:left-60 right-0 bg-custom-black">
        <div className="flex flex-col items-center justify-center">
          <div className="h-128 mt-2 w-10/12">
            <CreatorDashboardProfileCoverPhoto
              image={this.props.creatorBackgroundBlurredImage}
              setCreatorBackgroundBlurredImage={this.props.setCreatorBackgroundBlurredImage}
            />
            <CreatorDashboardProfileProfilePicture
              image={this.props.creatorImage}
              setCreatorImage={this.props.setCreatorImage}
            />
          </div>
          <div className="flex flex-col justify-center items-center w-full">
            <div className="flex flex-col items-center justify-center w-10/12">
              <CreatorDashboardProfileUsername
                creatorAddress={this.props.creatorAddress}
                route={this.props.route}
                username={this.props.username}
                setRoute={this.props.setRoute}
                setUsername={this.props.setUsername}
              />
              <CreatorDashboardProfileSocials
                discord={this.props.discord}
                instagram={this.props.instagram}
                spotify={this.props.spotify}
                twitter={this.props.twitter}
                setDiscord={this.props.setDiscord}
                setTwitter={this.props.setTwitter}
                setSpotify={this.props.setSpotify}
                setInstagram={this.props.setInstagram}
              />
              <div
                className="cursor-pointer my-8 w-60 sm:w-80 bg-blue-600 h-12 rounded-lg font-semibold text-white flex justify-center items-center"
                onClick={async () => await this.props.submitProfileInfo()}
              >
                Submit
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreatorDashboardProfile;
